import {useState, useEffect} from 'react';

import {statsApi} from '../http/Api';

export const useStats = () => {
  const [detected, setDetected] = useState(null);
  const [members, setMembers] = useState(null);
  const [guilds, setGuilds] = useState(null);
  const [detectedLoading, setDetectedLoading] = useState(true);
  const [membersLoading, setMembersLoading] = useState(true);
  const [guildsLoading, setGuildsLoading] = useState(true);

  const fetchDetected = async () => {
    try {
      const {data} = await statsApi.getDetection();
      setDetected(data?.count);
      setDetectedLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchMembers = async () => {
    try {
      const {data} = await statsApi.getMembers();
      setMembers(data?.count);
      setMembersLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const getGuilds = async () => {
    try {
      const {data} = await statsApi.getGuilds();
      setGuilds(data?.count);
      setGuildsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchDetected();
    fetchMembers();
    getGuilds();
  }, []);

  return {
    stats: {
      detected,
      members,
      guilds,
      workDays: Math.floor((new Date() - new Date(2022, 0, 1)) / (1000 * 60 * 60 * 24)),
    },
    loading: detectedLoading || membersLoading || guildsLoading,
  };
};
